export const composeEllipsisAriaLabelText = "d6a";
export const encryptMenuText = "e6a";
export const encryptDisableForwardingMenuText = "f6a";
export const hideFrom = "g6a";
export const switchToHTMLMenuItem = "h6a";
export const composePostButtonLabel = "i6a";
export default {composeEllipsisAriaLabelText,encryptMenuText,encryptDisableForwardingMenuText,hideFrom,switchToHTMLMenuItem,composePostButtonLabel};